import React, { Component } from 'react';
import { Link } from 'react-router-dom';

export class MobileNavBar extends Component {
  render() {
    const logoProps = {
      src: this.props.logo,
      style: { width: this.props.logoWidth },
    };
    return (
      <div>
        <div className="mobileNavBarV2Placeholder"></div>
        <div className="mobileNavBarV2">
          {this.props.authenticated && (
            <i className="material-icons" onClick={this.props.toggleCollapsed}>
              reorder
            </i>
          )}
          <Link to={this.props.logoUrl ? this.props.logoUrl : '/'}>
            <img {...logoProps} className="logo" alt="Go4" />
          </Link>
        </div>
      </div>
    );
  }
}

export default MobileNavBar;
